/**
 * Set notifications using cscart native notifications.
 */
export class Notifications {
    /**
     * Static method that sends request to front end controller to set notification.
     * Notification types:
     * E - error, W - warning, N - notice, O - order error on checkout, I - information
     *
     * @param {string} type of notification to display
     * @param {string} title for notification
     * @param {string} message for notification
     * @param {boolean} message_is_lang_var flag for whether message is a language variable.
     * @returns {void}
     */
    static set_notification(type: string, title: string, message: string, message_is_lang_var: boolean = false) : void {
        $.ceAjax('request', 'index.php?dispatch=tv_utils.set_notification', {
            method: 'POST',
            cache: false,
            data: {
                notification: {
                    type: type,
                    title: title,
                    message: message,
                    message_is_lang_var: message_is_lang_var
                }
            }
        });
    }
 }
